import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CurrentSizeDialogPage } from './current-size-dialog.page';

const routes: Routes = [
  {
    path: '',
    component: CurrentSizeDialogPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CurrentSizeDialogPageRoutingModule {}
